"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.injectCSS = injectCSS;
exports.removeCSS = removeCSS;
exports.updateCSS = updateCSS;

var _utils = require("./utils");

var containerCache = new Map();
var MARK_KEY = "enphase-util-key";

function getContainer() {
  var head = document.querySelector('head');
  return head || document.body;
}

function injectCSS(css) {
  if (!(0, _utils.canUseDom)()) {
    return null;
  }

  var styleNode = document.createElement('style');
  styleNode.innerHTML = css;
  var container = getContainer();
  container.appendChild(styleNode);
  return styleNode;
}

function findExistNode(key) {
  var container = getContainer();
  return Array.from(containerCache.get(container).children).find(node => node.tagName === 'STYLE' && node.getAttribute(MARK_KEY) === key);
}

function removeCSS(key) {
  var _existNode$parentNode;

  var existNode = findExistNode(key);
  existNode === null || existNode === void 0 ? void 0 : (_existNode$parentNode = existNode.parentNode) === null || _existNode$parentNode === void 0 ? void 0 : _existNode$parentNode.removeChild(existNode);
}

function updateCSS(css, key) {
  var container = getContainer(); // Get real parent

  if (!containerCache.has(container)) {
    var placeholderStyle = injectCSS('');
    var {
      parentNode
    } = placeholderStyle;
    containerCache.set(container, parentNode);
    parentNode.removeChild(placeholderStyle);
  }

  var existNode = findExistNode(key);

  if (existNode) {
    if (existNode.innerHTML !== css) {
      existNode.innerHTML = css;
    }

    return existNode;
  }

  var newNode = injectCSS(css);
  newNode.setAttribute(MARK_KEY, key);
  return newNode;
}